import { Flex, Grid } from '@mantine/core';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { OrganizationAuthPolicyCard as OrganizationAuthPolicy } from '@dealstack/frontend/app/pages/Organization/OrganizationAuthentication/components/OrganizationAuthPolicyCard/OrganizationAuthPolicyCard';
import { OrganizationDomain } from '@dealstack/frontend/app/pages/Organization/OrganizationAuthentication/components/OrganizationDomain/OrganizationDomain';

interface Props {
	name: string;
	auth2FAEnabled: boolean;
	ssoEnabled: boolean;
	emailDomains: string[];
}

const getMfaStatus = ({
	ssoEnabled,
	auth2FAEnabled,
}: {
	ssoEnabled: boolean;
	auth2FAEnabled: boolean;
}): 'enabled' | 'disabled' | 'unavailable' => {
	if (ssoEnabled) {
		return 'unavailable';
	} else if (auth2FAEnabled) {
		return 'enabled';
	} else {
		return 'disabled';
	}
};

export const OrganizationAuthentication = ({ auth2FAEnabled, ssoEnabled, emailDomains }: Props) => {
	const tOrganization = useTranslationOrganization();
	const ssoStatus = ssoEnabled ? 'enabled' : 'disabled';
	const mfaStatus = getMfaStatus({ ssoEnabled, auth2FAEnabled });

	return (
		<Flex p="1rem" align="flex-start">
			<Grid gutter="lg">
				<Grid.Col span={6}>
					<OrganizationAuthPolicy
						status={ssoStatus}
						title={tOrganization(`sso.title.${ssoStatus}`)}
						subtitle={tOrganization(`sso.subtitle.${ssoStatus}`)}
						description={tOrganization(`sso.description.${ssoStatus}`)}
						buttonText={tOrganization(`sso.buttonText.${ssoStatus}`)}
						body={tOrganization(`sso.body.${ssoStatus}`)}
						subject={tOrganization(`sso.subject.${ssoStatus}`)}
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<OrganizationAuthPolicy
						status={mfaStatus}
						title={tOrganization(`2fa.title.${mfaStatus}`)}
						subtitle={tOrganization(`2fa.subtitle.${mfaStatus}`)}
						description={tOrganization(`2fa.description.${mfaStatus}`)}
						buttonText={tOrganization(`2fa.buttonText.${mfaStatus}`)}
						body={tOrganization(`2fa.body.${mfaStatus}`)}
						subject={tOrganization(`2fa.subject.${mfaStatus}`)}
					/>
				</Grid.Col>
				<Grid.Col span={6}>
					<OrganizationDomain domains={emailDomains} />
				</Grid.Col>
				<Grid.Col span={6}>{/* Empty right-bottom space */}</Grid.Col>
			</Grid>
		</Flex>
	);
};
